import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTenant } from '../../../contexts/TenantContext'
import { Content } from './style'
import { OptionsButton, LeftSide, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv, ButtonCreate, RefreshIcon, RefreshIconContainer } from '../../../components/styles/subheader-style'
import stock from '../../../assets/stock/TableMovementHeader/list-active.svg'
import movement from '../../../assets/stock/TableMovementHeader/refresh-active.svg'
import { Outlet, useNavigate, useOutletContext, useLocation } from 'react-router-dom'
import ModalContext from '../../../contexts/ModalContext'
import { TypeMainOutlet } from '..'
import { tableFields, fashionStockDefault } from '../../../components/FieldManager/table-fields'
import FieldsManager, { FieldsManagerType } from '../../../components/FieldManager'
import WithoutSelectedFields from '../../SystemErrors/WithoutSelectedFields'
import StockContext from '../../../contexts/StockContext'
import FiltersMenu from '../../../components/Stock/TableMovementHeader/FiltersMenu'
import filter from '../../../assets/stock/TableMovementHeader/filter.svg'
import FiltersHeader from '../../../components/Stock/FiltersHeader'
import TableFiltersContext from '../../../contexts/TableFiltersContext'
import SectionContext from '../../../contexts/SectionContext'
import refresh_act from '../../../assets/refresh-active.svg'
import resource from '../../../assets/home/resource.svg'
import receipt from '../../../assets/home/receipt.svg'
import steel from '../../../assets/home/steel.svg'
import { CompanyTypes, FilterTypesDiv } from '../../../components/Stock/TableMovementHeader/style'
import axios from '../../../config/axios'
import ProductFinals from '../ProductFinal'
import SalesStockDashboard, { SalesStockToolbar, useSalesStockState } from './SalesStock'
import { ArrowDown } from 'lucide-react'

export interface StockOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
  fields: FieldsManagerType
  setFields: React.Dispatch<React.SetStateAction<FieldsManagerType>>
  isdropdownOpen: boolean
  setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>
  quantity: number
  setQuantity: React.Dispatch<React.SetStateAction<number>>
}

const steelTabs = [
  { path: '/panel/stock', image: stock, name: 'Matéria prima', external: false },
  { path: '/panel/resource', image: resource, name: 'Insumos', external: false },
  { path: '/panel/product-final', image: steel, name: 'Produto engenheirado', external: true }
]

const fashionTabs = [
  { path: '/panel/stock', image: stock, name: 'Tecidos', external: false },
  { path: '/panel/stock/resource', image: resource, name: 'Aviamentos', external: false },
  { path: '/panel/stock/sales', image: receipt, name: 'Vendas', external: false }
]

const StockSubHeader: React.FC<{ tabIndexActived: number, handleTabChange: (index: number) => void, salesStockState?: ReturnType<typeof useSalesStockState> }> = ({ tabIndexActived, handleTabChange, salesStockState }) => {
  const navigate = useNavigate()
  const companyTypesIds = ['Pedido', 'Manual']
  const { setModalActive, setModalSection, setStockMode } = useContext(ModalContext)
  const { stockFilters } = useContext(TableFiltersContext)
  const { resetContext, setRefresh: setContextRefresh, isLoading } = useContext(StockContext)
  const [isFiltersMenuOpen, setIsFiltersMenuOpen] = useState<boolean>(false)
  const filterMenuRef = useRef<HTMLDivElement>(null)
  const filterDropdownRef = useRef<HTMLDivElement>(null)
  const { movementTypeFilter, setMovementTypeFilter } = useContext(TableFiltersContext)
  const [stockInfo, setStockInfo] = useState({ totalWeight: 0, totalItems: 0 })


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterMenuRef.current &&
        filterDropdownRef.current &&
        !filterMenuRef.current.contains(event.target as Node) &&
        !filterDropdownRef.current.contains(event.target as Node)
      ) {
        setIsFiltersMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const fetchStockInfo = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/stock/getTotalStock`);
      setStockInfo(response.data);
    } catch (error) {
      console.error('Erro ao buscar dados do estoque:', error);
    }
  };


  useEffect(() => {
    fetchStockInfo();
  }, []);

  const handleSetTypes = (id: string) => {
    if (movementTypeFilter.includes(id)) {
      if (movementTypeFilter.split(',').length === 1) {
        return
      }
      setMovementTypeFilter(
        movementTypeFilter
          .split(',')
          .filter((item) => item !== id)
          .join(',')
      )
    } else {
      setMovementTypeFilter(movementTypeFilter ? `${movementTypeFilter},${id}` : id)
    }
  }

  const openModal = () => {
    resetContext()
    if (isFashionTenant) {
      setStockMode('fashion')
    }
    setModalActive(true)
    setModalSection('addStockMenu')

  }
  const openExportModal = () => {
    const filters = stockFilters
    const columns = JSON.parse(localStorage.getItem('tableFields') || '[]')[1].whichFieldsToShow.filter((field: { checked: boolean, field: string, fieldName: string }) => field.checked)
    const body = {
      filters,
      columns
    }
    navigate('/panel/stock/export')
  }

  const { isFashionTenant } = useTenant()

  const sectionTitles = isFashionTenant
    ? ["Tecidos", "Aviamentos", "Vendas"]
    : ["Matéria prima", "Insumos", "Produto engenheirado"]
  const currentTitle = sectionTitles[tabIndexActived] || (isFashionTenant ? "Tecidos" : "Matéria prima")

  const visibleTabs = isFashionTenant ? fashionTabs : steelTabs

  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName title={`Peso total: ${stockInfo.totalWeight.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })} kg\nItens totais: ${stockInfo.totalItems}`}>Estoque</SectionName>
        <TabsDiv>
          {visibleTabs.map((tab, index) => {
            const isFirst = index === 0
            const isLast = index === visibleTabs.length - 1
            return (
              <Tab
                key={index}
                $isFirst={isFirst}
                $isLast={isLast}
                $isActive={index === tabIndexActived}
                onClick={() => {
                  if (index !== tabIndexActived) {
                    handleTabChange(index)
                    if (tab.external) {
                      navigate(tab.path)
                      return
                    }
                    navigate(tab.path)
                  }
                }}
              >
                <img src={tab.image} alt={`${tab.path}-icon`} />
                {tab.name}
              </Tab>
            )
          })}
        </TabsDiv>
      </LeftSide>
      <RightSide>
        {tabIndexActived === 2 && salesStockState ? (
          <SalesStockToolbar state={salesStockState.toolbarState} />
        ) : (
          <>
            {tabIndexActived === 1 ?
              <ButtonCreate onClick={() => navigate('/panel/stock/resource/create')}>+ {isFashionTenant ? 'Adicionar Aviamento' : 'Adicionar Insumo'}</ButtonCreate> : null}
            {tabIndexActived === 0 ?
              <>
                <RefreshIconContainer onClick={() => setContextRefresh((prev: boolean) => !prev)} title="Atualizar">
                  <RefreshIcon src={refresh_act} alt="Movement icon" $spinning={!!isLoading} />
                </RefreshIconContainer>
                <OptionsButton onClick={() => setIsFiltersMenuOpen(!isFiltersMenuOpen)} ref={filterMenuRef}>
                  <img src={filter} alt="filter-icon" />
                </OptionsButton>
              </>
              : null}
            {tabIndexActived === 0 ?
              <>
                <ButtonCreate onClick={() => openExportModal()}>Exportar estoque</ButtonCreate>
                <ButtonCreate onClick={() => openModal()}>+ {isFashionTenant ? 'Adicionar Tecido' : 'Adicionar Estoque'}</ButtonCreate>
              </>
              : null}
          </>
        )}
        {isFiltersMenuOpen ? <FiltersMenu ref={filterDropdownRef} anchorRef={filterMenuRef} /> : null}
      </RightSide>

    </SubHeaderContainer>
  )
}

const StockContent = () => {
  const [isdropdownOpen, setIsDropdownOpen] = useState(false)
  const location = useLocation()
  const [tabIndex, setTabIndex] = useState<number>(0)
  const { search } = useOutletContext<TypeMainOutlet>()
  const { stockFilters, movementFilters } = useContext(TableFiltersContext)
  const { stockSection } = useContext(SectionContext)
  const { stockList, hasMoreStock, isLoading } = useContext(StockContext)
  const { stockMode } = useContext(ModalContext)
  const { isFashionTenant } = useTenant()
  const isFashion = isFashionTenant || stockMode === 'fashion'
  const salesStock = useSalesStockState(isFashionTenant)
  const fashionHiddenFields = ['heatTreatment', 'density']
  const [quantity, setQuantity] = useState(50)

  // Chaves separadas de localStorage para modo industrial e fashion
  const localStorageKey = isFashion ? 'tableFieldsFashion' : 'tableFields'
  const fromLocalStorage = localStorage.getItem(localStorageKey)

  // Se não há nada no localStorage, usa o default correto para o modo atual
  const defaultFromTable = isFashion
    ? fashionStockDefault
    : (tableFields.find(field => field.tableSection === 'stock') || tableFields[0])

  const tableFieldsJson: FieldsManagerType[] = fromLocalStorage
    ? JSON.parse(fromLocalStorage)
    : (isFashion ? [fashionStockDefault] : tableFields)

  let foundFields = tableFieldsJson.find(field => field.tableSection === 'stock')

  if (isFashion && foundFields) {
    const hasColorField = foundFields.whichFieldsToShow.some(field => field.field === 'color')
    if (!hasColorField) {
      foundFields = fashionStockDefault
    }
  }

  const defaultFields = (foundFields && foundFields.whichFieldsToShow.some(field => field.checked))
    ? foundFields
    : defaultFromTable
  const [section, setSection] = useState<'stock' | 'movement' | 'resource' | 'sales'>('stock')
  const [fields, setFields] = useState<FieldsManagerType>(defaultFields as FieldsManagerType)
  const headerTabIndex = section === 'resource' ? 1 : section === 'sales' ? 2 : 0

  useEffect(() => {
    if (section === 'resource') {
      return
    }
    const toLocalStorage = tableFieldsJson.map((table: FieldsManagerType) => {
      if (table.tableSection === section) {
        return { ...table, whichFieldsToShow: fields.whichFieldsToShow }
      }
      return table
    })

    localStorage.setItem(localStorageKey, JSON.stringify(toLocalStorage))
  }, [fields, section])

  useEffect(() => {
    if (section === 'resource') {
      setIsDropdownOpen(false)
      return
    }
    const updatedFields = tableFieldsJson.find(field => field.tableSection === section)
    const defaultSectionFields = isFashion
      ? fashionStockDefault
      : tableFields.find(field => field.tableSection === section)

    let fieldsToUse = (updatedFields && updatedFields.whichFieldsToShow.some(field => field.checked))
      ? updatedFields
      : defaultSectionFields

    if (isFashion && section === 'stock' && fieldsToUse) {
      const hasColorField = fieldsToUse.whichFieldsToShow.some(field => field.field === 'color')
      if (!hasColorField) {
        fieldsToUse = fashionStockDefault
      }
    }

    if (fieldsToUse) {
      setFields(fieldsToUse)
    }
  }, [section])

  useEffect(() => {
    const basePath = '/panel/stock'
    if (!location.pathname.startsWith(basePath)) {
      setSection('stock')
      setTabIndex(0)
      return
    }

    const remainder = location.pathname.slice(basePath.length)
    const segments = remainder.split('/').filter(segment => segment.length > 0)
    const primarySegment = segments[0] || ''

    if (primarySegment === 'movement') {
      setSection('movement')
      setTabIndex(0)
      return
    }

    if (['resource', 'create', 'edit', 'view'].includes(primarySegment)) {
      setSection('resource')
      setTabIndex(1)
      return
    }

    if (primarySegment === 'sales') {
      setSection('sales')
      setTabIndex(2)
      return
    }

    setSection('stock')
    setTabIndex(0)
  }, [location.pathname])

  const handleTabSelection = (index: number) => {
    if (index === 2 && isFashionTenant) {
      setSection('sales')
      setTabIndex(2)
      return
    }

    if (index === 1) {
      setSection('resource')
      setTabIndex(1)
      return
    }

    if (index === 0) {
      setSection('stock')
      setTabIndex(0)
      return
    }

    setTabIndex(index)
  }

  const renderSubHeader = () => {
    if (location.pathname.includes('panel/product-final')) {
      return <ProductFinals />
    }
    return <StockSubHeader tabIndexActived={headerTabIndex} handleTabChange={handleTabSelection} salesStockState={section === 'sales' ? salesStock : undefined} />
  }

  const shouldShowFieldManager = section !== 'resource' && section !== 'sales'
  const hasSelectedFields = fields?.whichFieldsToShow?.some(field => field.checked)

  const outletContext = {
    tabIndex,
    setTabIndex,
    search,
    fields,
    setFields,
    isdropdownOpen,
    setIsDropdownOpen,
    quantity,
    setQuantity,
  }

  return (
    <>
      {renderSubHeader()}
      {shouldShowFieldManager && stockSection === 'stock' && stockFilters.length > 0 ? <FiltersHeader /> : null}
      {shouldShowFieldManager && stockSection === 'movement' && movementFilters.length > 0 ? <FiltersHeader /> : null}
      <Content>
        {section === 'sales' ? (
          <SalesStockDashboard
            state={salesStock.toolbarState}
            items={salesStock.items}
            filtered={salesStock.filtered}
            isLoading={salesStock.isLoading}
            expandedGroups={salesStock.expandedGroups}
            setExpandedGroups={salesStock.setExpandedGroups}
          />
        ) : shouldShowFieldManager && !hasSelectedFields ? (
          <WithoutSelectedFields dropdown={setIsDropdownOpen} />
        ) : (
          <Outlet context={outletContext} />
        )}
      </Content>
    </>
  );
};

export const StockResourceLayout = () => {
  const context = useOutletContext<TypeMainOutlet>()
  return <Outlet context={{ search: context?.search || '' }} />
}

export default StockContent;